import React, { FC, ReactElement, useState } from "react";
import { AppBar, Box, Button, Toolbar, IconButton, Drawer, Typography, Divider } from "@mui/material";
import { Info as InfoIcon, Launch as LaunchIcon } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router";
import { ENVIRONMENT, version, DDB_ENVIRONMENT } from "../../shared/config";

let actionButton: ReactElement;

export function setActionButton(element: ReactElement) {
  actionButton = element;
}

function getActionButton(): ReactElement {
  if (actionButton) {
    return actionButton as ReactElement;
  }
  return <></>;
}

const BottomBar: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const actionButton = getActionButton();
  const isRootPath = location.pathname === "/";

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleDocumentationClick = () => {
    window.open("https://docs.ddb.arup.com/", "_blank");
  };

  return (
    <>
      <AppBar data-testid="bottom-bar" position="static" color="transparent">
        <Toolbar>
          <Box sx={{ display: "grid", gap: 4, width: "100%", padding: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                  color="primary"
                  data-testid="info-button"
                  onClick={handleOpenDrawer}
                  size="small"
                  aria-label="Show info drawer"
                >
                  <InfoIcon />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  "& .MuiButton-root:not([data-testid='back-button'])": {
                    backgroundColor: "primary.main",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                  },
                }}
                data-testid="action-button-container"
              >
                {!isRootPath && (
                  <Button
                    data-testid="back-button"
                    variant="text"
                    onClick={() => navigate(-1)}
                    aria-label="Go back to the previous page"
                  >
                    Back
                  </Button>
                )}
                {actionButton}
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        data-testid="info-drawer"
        PaperProps={{
          sx: {
            backgroundColor: "white",
            padding: 6,
          },
        }}
      >
        <Box sx={{ maxWidth: 600, margin: "0 auto", width: "100%" }}>
          <Button
            variant="text"
            size="medium"
            onClick={handleDocumentationClick}
            startIcon={<LaunchIcon />}
            sx={{
              paddingBottom: 6,
            }}
            fullWidth
            data-testid="documentation-button"
          >
            View Documentation
          </Button>
          <Typography variant="subtitle2" data-testid="version-label">
            VERSION:
          </Typography>
          <Typography
            variant="body2"
            sx={{
              marginBottom: 4,
              wordWrap: "break-word",
              whiteSpace: "normal",
              lineHeight: 1.5,
            }}
            data-testid="version-info"
          >
            Environment: {ENVIRONMENT} Version: {version} DDB Environment: {DDB_ENVIRONMENT}
          </Typography>
          <Divider sx={{ marginBottom: 4 }} />
          <Button variant="text" size="small" onClick={handleCloseDrawer} data-testid="cancel-button">
            Cancel
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default BottomBar;
